import { IconButton, useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ResourceType } from 'json-api-hooks';
import React from 'react';
import FontAwesome from 'react-fontawesome';

import useModalDispatch from '../../hooks/useModalDispatch';
import CreateResourceModal, { CreateResourceModalProps } from '../../modals/CreateResourceModal';
import { BreakPoints } from '../../theme/types';
import Button from '../Button';
import { Trigger, TriggerButtonProps } from '../DropdownMenu/TriggerButton';

import CollectionCreateDropdown from './CollectionCreateDropdown';

const TextWithIconTrigger: Trigger<TriggerButtonProps> = ({ anchorRef, onClick, title }) => {
  const theme = useTheme();
  const screenIsNarrow = useMediaQuery(theme.breakpoints.down(BreakPoints.Medium));

  if (screenIsNarrow) {
    return (
      <IconButton aria-label={title} ref={anchorRef}>
        <FontAwesome name="plus" onClick={onClick} />
      </IconButton>
    );
  }

  return (
    <Button buttonRef={anchorRef} icon="plus" variant="text" onClick={onClick}>
      {title}
    </Button>
  );
};

export interface Action {
  onClick: () => void;
  label: string;
}

export const CollectionCreateMultipleButton: React.FC<{ actions: Action[] }> = ({ actions }) => (
  <CollectionCreateDropdown actions={actions} triggerComponent={TextWithIconTrigger} />
);

export const CollectionCreateSingleButton = <T extends ResourceType>(
  props: Omit<CreateResourceModalProps<T>, 'handleClose'>,
) => {
  const openModal = useModalDispatch<CreateResourceModalProps<T>>(CreateResourceModal);

  return <TextWithIconTrigger title={props.label} onClick={() => openModal(props)} />;
};
